import React, { useEffect, useState } from 'react'
import { Spin, Tooltip, Typography } from 'antd'
import { useSelector, useDispatch } from 'react-redux';

import AgGrid from "../../../../../components/ag-grid-table/index";
import ProgressBar from '../../../../../components/uiComponent/progressBar/index.js'
import Badge from '../../../../../components/uiComponent/bages/index.js';
import Button from "../../../../../components/uiComponent/button/index";
import Modal from "../../../../../components/uiComponent/modal"

import { DeleteModalStyleWrapper } from "../../../../../containers/logistics/orders/warehouse/shipping/style.js"
import { STORAGE_ICON_URL, STORAGE_IMAGE_URL } from '../../../../../constants/storage.js';

import {
  CancelInboundPlan,
  GetShipmentDetails
} from '../../../../../slices/shipment-plan.js';

import { ConfirmPlacementWrapper } from './style'
import { useNavigate, useParams } from 'react-router-dom';
import { capitalize } from 'lodash';

const ProductImg = `${STORAGE_IMAGE_URL}/newImages/nestle.svg`;
const ArrowIcon =  `${STORAGE_ICON_URL}/circle-right-arrow.svg`;
const WarningInfoIcon = `${STORAGE_IMAGE_URL}/newImages/info-icon.svg`;
const WarningIcon = `${STORAGE_ICON_URL}/warning-modal-icon.svg`

const defaultColDef = {
  resizable: true,
  sortable: false,
  filter: false,
  suppressRowClickSelection: true,
  suppressMenu: true,
  suppressMovable: true,
};

const ConfirmPlacement = () => {

  const [isDeleteBox, setIsDeleteBox] = useState(false);

  const dispatch = useDispatch();

  const { workOrderId } = useParams();
  const navigate = useNavigate();

  const {
    inboundPlanId,
  } = useSelector((state) => state.workOrders || {});

  const {
    cancelingInboundPlan
  } = useSelector((state) => state.shipmentPlan || {});

  const handleCancelInboundPlan = () => {
    setIsDeleteBox(true)
    dispatch(CancelInboundPlan({
      inboundPlanId,
      workOrderId
    }))
      .then(({ payload }) => {
        if (payload?.success) navigate(`/inventory/work-order/${workOrderId}`);
      });
  };

  const {
    fetchingShipmentDetails,
    shipments = [],
    workOrder = {},
    workOrderItems = [],
    addressInfo = {},
  } = useSelector((state) => state.shipmentPlan || {});

  useEffect(() => {
    dispatch(GetShipmentDetails({
      workOrderId
    }));
  }, [workOrderId]);

  const columnDefs = [
    {
      headerName: "Product Name",
      field: "items",
      flex: 1,
      cellRenderer: ({ data }) => (
        <div className='product-item-wrapper'>
          <img
            src={data?.image_url || ProductImg}
            alt="Product"
          />
          <Tooltip title={data?.item_name || 'N/A'}>
            <span className='product-item'>{data?.item_name || 'N/A'}</span>
          </Tooltip>
        </div>
      ),
    },
    {
      headerName: "SKU",
      field: "sku",
      flex: 1,
      cellRenderer: ({ data }) => (
        <Tooltip title={data?.msku || 'N/A'}>
          <p>{data?.msku || 'N/A'}</p>
        </Tooltip>
      ),
    },
    {
      headerName: "ASIN",
      field: "asin",
      flex: 1,
      cellRenderer: ({ data }) => (
        <Tooltip title={data?.asin || 'N/A'}>
          <p>{data?.asin || 'N/A'}</p>
        </Tooltip>
      ),
    },
    {
      headerName: "Ship Quantity",
      field: "quantity",
      flex: 1,
      cellRenderer: ({ data }) => (
        <p>{data?.quantity || '0'}</p>
      ),
    },
    {
      headerName: "Packed Quantity",
      field: "boxed_quantity",
      sortable: true,
      flex: 1,
      cellRenderer: ({ data }) => (
        <p>{data?.boxed_quantity || '0'}</p>
      ),
    },
  ];

  const { wh_name = '', address_line_1 = '', city = '', state_or_province = '', zipcode = '', country = '' } = addressInfo || {};
  const address = `${wh_name}, ${address_line_1}, ${city}, ${state_or_province} ${zipcode}, ${country}`;

  return (
    <ConfirmPlacementWrapper>
      <header>
        <div className='items-wrapper'>
          <p>Order Name</p>
          <p>{workOrder?.name || 'N/A'}</p>
        </div>
        {/* <div className='items-wrapper'>
          <p>Order Status</p>
          <p>{workOrder?.status || 'N/A'}</p>
        </div> */}
        <div className='items'>
          <label>Status</label>
          <Badge circleStatus status={capitalize(workOrder?.workOrderInfo?.status) || ''} />
        </div>
        <div className='items-wrapper'>
          <p>Type</p>
          <p>{workOrder?.workOrderInfo?.order_type || 'N/A'}</p>
        </div>
        <div className="items-wrapper">
          <p>Progress</p>
          {shipments?.length > 0 ? (() => {
            const { total, current } = shipments.reduce(
              (acc, shipment) => {
                const items = shipment.shipment_items_info || [];
                acc.total += items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
                acc.current += items.reduce((sum, item) => sum + Number(item.boxed_quantity || 0), 0);
                return acc;
              },
              { total: 0, current: 0 }
            );

            let status = 'grey';

            if (current === 0) {
              status = 'grey'
            }
            else if (total === current) status = 'success'
            else if (current < total) status = 'warning'
            else status = 'warning'

            return (
              <p>
                <ProgressBar status={status} labelText="Packed" current={current} total={total} />
              </p>
            );
          })() : (
            <p>---</p>
          )}
        </div>
        <div className='items-wrapper'>
          <p>Ship from Address</p>
          <p>{address_line_1 ? address : '1057 Pennsylvania Ave linden nj 07036'}</p>
        </div>
        <div className='items-wrapper'>
          <p>Label Owner</p>
          <p>{workOrder?.workOrderInfo?.label_owner || 'NONE'}</p>
        </div>
        <div className='items-wrapper'>
          <p>Box Packing  Information</p>
          <p>{workOrder?.workOrderInfo?.box_packing_information}</p>
        </div>
      </header>
      <div className='content-wrapper'>
        <div className='table-content'>
          <h2>Items</h2>
          <Spin tip='Loading...' spinning={fetchingShipmentDetails || cancelingInboundPlan}>
            <AgGrid
              user_referrals={workOrderItems}
              defaultColDef={defaultColDef}
              columnDefinitions={columnDefs}
              rowHeight={64}
              headerHeight={36}
              height="310px"
              masterDetail={true}
              detailRowAutoHeight={true}
              className="sku-table"
            />
          </Spin>
        </div>
        <div className='cards-content'>
          <div
            className="flex"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline"
            }}
          >
            <h2>Shipments details</h2>
          </div>
          <div className='cards-container'>
            <div className='active-item-wrapper'>
              <div className='item'>
                <p>Placement Option</p>
                <p>Placement Option 1</p>
              </div>
              <div className='item'>
                <p>Shipments</p>
                <p>{shipments?.length || '0'}</p>
              </div>
              <div className='item'>
                <p>Placement Fee</p>
                <p>${workOrder?.placement_fee || 0}</p>
              </div>
            </div>
            <div className='products-cards'>
              {shipments.map((shipment, index) => {
                const {
                  amazon_shipment_confirmation_id,
                  totalSkus,
                  totalUnits,
                  destination_city,
                  destination_postal_code,
                  amazon_warehouse_id,
                } = shipment || {};

                return (
                  <div key={shipment.id} className='cards-items'>
                    <div className='item'>
                      <div className='cards-header'>
                        <p>Shipment {index + 1}</p>

                        {(() => {
                          const shipmentItems = Array.isArray(shipment.shipment_items_info)
                            ? shipment.shipment_items_info
                            : JSON.parse(shipment.shipment_items_info || '[]');

                          const current = shipmentItems.reduce((sum, item) => sum + (Number(item.boxed_quantity) || 0), 0);
                          const total = shipmentItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);

                          let status = 'grey';

                          if (current === 0) {
                            status = 'grey'
                          }
                          else if (total === current) status = 'success'
                          else if (current < total) status = 'warning'
                          else status = 'warning'

                          return (
                            <ProgressBar
                              status={status}
                              className="work-order-placement"
                              labelText="Packed"
                              current={current}
                              total={total}
                            />
                          );
                        })()}
                      </div>
                      {/* <img src={ArrowIcon} alt="Arrow Icon" onClick={() => handleImageClick(shipment?.id)} style={{ cursor: 'pointer' }} /> */}
                    </div>
                    <div className='row-items'>
                      <div className='items'>
                        <p>Shipment ID</p>
                        <p>
                          <Tooltip title={amazon_shipment_confirmation_id}>
                            {amazon_shipment_confirmation_id}
                          </Tooltip>
                        </p>
                      </div>
                      <div className='items'>
                        <p>FC ID</p>
                        <Tooltip title={amazon_warehouse_id}>
                          <p className='fc-address'>{amazon_warehouse_id}</p>
                        </Tooltip>
                      </div>
                      <div className='items'>
                        <p>City</p>
                        <Tooltip title={destination_city}>
                          <p className='fc-address'>{destination_city}</p>
                        </Tooltip>
                      </div>
                      <div className='items'>
                        <p>Postal Code</p>
                        <Tooltip title={destination_postal_code}>
                          <p className='fc-address'>{destination_postal_code}</p>
                        </Tooltip>
                      </div>
                      <div className='items'>
                        <p>Total SKUs</p>
                        <p>{totalSkus || '0'}</p>
                      </div>
                      <div className='items'>
                        <p>Total Units</p>
                        <p>{totalUnits || '0'}</p>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <Button
            text="Cancel Plan"
            className="danger mt-2 ms-auto mb-0"
            minWidth="90px"
            disabled={cancelingInboundPlan}
            onClick={() => setIsDeleteBox(true)}
          />
        </div>
      </div>
      <Modal
        saveText="Yes"
        className="Delete-modal-wrapper-item"
        onClose={() => setIsDeleteBox(false)}
        onSave={handleCancelInboundPlan}
        buttonDisabled={cancelingInboundPlan}
        closeText="No"
        centerAlign
        size="small"
        open={isDeleteBox}
        removeIcon
      >
        <DeleteModalStyleWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
            <Typography fontSize={24} component="h3" marginTop={3}>Warning</Typography>
            <span className='modal-body'>
            <p>Are you sure you want to cancel this Plan?</p>
            </span>
          </div>
        </DeleteModalStyleWrapper>
      </Modal>
    </ConfirmPlacementWrapper>
  )
}

export default ConfirmPlacement;
